import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/visao-geral`;

const visaoGeralApi = {
  getNotificarGeracaoRemessa: () => {
    const url = `${getPath()}/notificar-geracao-remessa`;
    return axios.get(url);
  },
  buscarSaldoContas: () => {
    const url = `${getPath()}/dashboard/saldo`;
    return axios.get(url);
  },
  buscaContasPagar: (periodo) => {
    const url = `${getPath()}/dashboard/contas-pagar`;
    return axios.get(url, { params: periodo });
  },
  buscaContasReceber: (periodo) => {
    const url = `${getPath()}/dashboard/contas-receber`;
    return axios.get(url, { params: periodo });
  },
  buscarInadimplencia: () => {
    const url = `${getPath()}/grafico/inadimplencia`;
    return axios.get(url);
  },
  buscarReceitasDespesas: () => {
    const url = `${getPath()}/grafico/receitas-despesas`;
    return axios.get(url);
  },
  buscarFluxoCaixa: () => {
    const url = `${getPath()}/grafico/fluxo-caixa`;
    return axios.get(url);
  },
  buscarDadosDashboardVendas: () => {
    const url = `${getPath()}/dashboard/vendas`;
    return axios.get(url);
  },
  buscarDadosGraficoVendas: (params) => {
    const url = `${getPath()}/grafico/vendas`;
    return axios.get(url, { params });
  },
  getNotificarCertificadoDigital: () => {
    const url = `${getPath()}/notificar-certificado-digital`;
    return axios.get(url);
  },
};

export { visaoGeralApi };
